/**
 * @GENERATED from Figma node 3638:51775
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const LucidDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <rect width={20} height={20} x={2} y={2} fill="#fff" rx={2} />
    <path
      fill="#282C33"
      d="M12.294 4 7 7v12l5.294-3zM17.588 19v-6.177l-5.294 3.188V19z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(LucidDark);
export { ForwardRef as LucidDark };
